import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { nonEmpty } from "../../../swzutils";
import { Button, Table } from "antd";
import React from "react";
import { formatDistance } from "../../../util/FormatUtil";
const SenderReceiverSelectTable = (props) => {
    return (_jsx(Table, { loading: props.loading, rowKey: (it) => it.senderReceiver?.id, size: "small", pagination: false, columns: [
            {
                title: 'Code',
                dataIndex: ['senderReceiver', 'code'],
            },
            {
                title: 'Company Name',
                dataIndex: ['senderReceiver', 'companyName'],
            },
            {
                title: 'Address',
                dataIndex: 'address',
                width: '30%',
                render: (text, record) => {
                    if (record.senderReceiver?.address) {
                        const address = record.senderReceiver.address;
                        return nonEmpty `${address.unitOrFlat} ${address.street} ${address.suburb} ${address.postcode} ${address.state}`;
                    }
                    return null;
                }
            },
            {
                title: 'Straight Line Distance',
                render: (value, record) => {
                    return formatDistance(record.distanceMeters, _jsx(_Fragment, { children: "\u2014" }));
                }
            },
            {
                title: 'Action',
                render: (value, record) => {
                    return _jsx(Button, { onClick: () => props.onSelected(record.senderReceiver), children: "Use" });
                }
            }
        ], dataSource: props.senderReceivers }));
};
export default SenderReceiverSelectTable;
